import styled, { css, DefaultTheme } from "styled-components";
import { ChoiceProps } from ".";

type ContainterProps = Pick<ChoiceProps, "size" | "isSelected">;

const containerModifiers = {
  medium: () => css`
    width: 11.56rem;
    height: 11.56rem;

    h1 {
      font-size: 1rem;
      font-weight: 500;
      margin-bottom: 1rem;
    }

    img {
      width: 6rem;
    }
  `,

  large: () => css`
    width: 20.125rem;
    height: 20.125rem;

    h1 {
      font-size: 1.25rem;
      font-weight: 600;
      margin-bottom: 1rem;
    }

    img {
      width: 11.6rem;
    }
  `,

  isSelected: (theme: DefaultTheme) => css`
    border: 2px solid ${theme.colors.primary};
  `,
};

export const Container = styled.button<ContainterProps>`
  ${({ theme, size, isSelected }) => css`
    background-color: #ffffff;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;

    color: ${theme.colors.green};
    text-align: center;
    margin-bottom: 1rem;

    ${containerModifiers[size || "large"]}

    ${isSelected && containerModifiers.isSelected(theme)}
  `}
`;
